import { render, staticRenderFns } from "./BookmarkControl.vue?vue&type=template&id=073b083a"
import script from "./BookmarkControl.vue?vue&type=script&lang=js"
export * from "./BookmarkControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports